import { render, staticRenderFns } from "./ViewFacebook.vue?vue&type=template&id=93ac5528&scoped=true&"
import script from "./ViewFacebook.vue?vue&type=script&lang=ts&"
export * from "./ViewFacebook.vue?vue&type=script&lang=ts&"
import style0 from "./ViewFacebook.vue?vue&type=style&index=0&id=93ac5528&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ac5528",
  null
  
)

export default component.exports